/**
 * Lead context parsing from URL parameters
 */

interface LocationLike {
  search: string;
  pathname: string;
}

export interface LeadContext {
  domain: string | null;
  origin_page: string;
  referrer: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term: string;
}

export function readLeadContext(location: LocationLike): LeadContext {
  const searchParams = new URLSearchParams(location.search);

  // Extract domain (required)
  const domain = searchParams.get('domain');

  // Derive origin_page from URL param or route
  let origin_page = searchParams.get('origin_page') || '';
  if (!origin_page) {
    // Fallback by route
    if (location.pathname.includes('/apply/free')) {
      origin_page = 'ApplyFree';
    } else if (location.pathname.includes('/apply/rto')) {
      origin_page = 'RTO';
    } else if (location.pathname.includes('/apply/offer')) {
      origin_page = 'MakeOffer';
    } else if (location.pathname.includes('/buy/bin')) {
      origin_page = 'BIN';
    }
  }

  // Get referrer from document (fallback to URL param for testing)
  const referrer =
    typeof document !== 'undefined' ? document.referrer : searchParams.get('referrer') || '';

  // Extract UTM parameters
  const utm_source = searchParams.get('utm_source') || '';
  const utm_medium = searchParams.get('utm_medium') || '';
  const utm_campaign = searchParams.get('utm_campaign') || '';
  const utm_term = searchParams.get('utm_term') || '';

  return {
    domain,
    origin_page,
    referrer,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_term,
  };
}

export function validateLeadContext(context: LeadContext): string | null {
  if (!context.domain) {
    return 'Domain parameter is required';
  }
  return null;
}
